(function() { window.GUID_e3f80960_23a8_4659_ae87_118c261e9b2d = { getGuid: function() { return "e3f80960-23a8-4659-ae87-118c261e9b2d"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let StatLayout;
        (function (StatLayout) {
            StatLayout[StatLayout["Cards"] = 0] = "Cards";
            StatLayout[StatLayout["Grid"] = 1] = "Grid";
        })(StatLayout = Enumeration.StatLayout || (Enumeration.StatLayout = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=StatLayout.pre.js.map
